




































import Vue from "vue";
export default Vue.extend({
  props: ["value", "size"],
  data() {
    return {
      isFoucs: false
    };
  }
});
